import { BrowserRouter } from 'react-router-dom';
import { NotificationType, useNotificationStore } from '@lib/store';
import { cn } from '@shared/utils';
import { Root } from '@routes';

export const App = () => {
  const notificationStore = useNotificationStore();

  return (
    <BrowserRouter>
      {notificationStore.notification?.message && (
        <div>
          <div
            className={cn(
              'fixed top-0 left-0 z-[1600] flex min-h-[54px] w-full items-center justify-center px-10 shadow-[12px_12px_24px_0_#0000003b]',
              notificationStore.notification?.type === NotificationType.ERROR && 'bg-[#e42d34] text-center',
              notificationStore.notification?.type === NotificationType.SUCCESS && [
                'bg-[#929292] text-left',
                'before:mr-3 before:block before:h-[18px] before:w-[24px] before:bg-[url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMTgiIHZpZXdCb3g9IjAgMCAyNCAxOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4gIDxwYXRoIGQ9Ik0yMy42MzYuMTU1Yy0uMTk5LS4yMDctLjUyLS4yMDctLjcxOSAwbC0xNS40MDMgMTYuMDA0LTYuNjQ2LTYuOTA1Yy0uMTk5LS4yMDctLjUyLS4yMDctLjcxOSAwLS4xOTkuMjA3LS4xOTkuNTQgMCAuNzQ3bDcuMDA1IDcuMjc4Yy4wOTkuMTAzLjIyOS4xNTUuMzU5LjE1NS4xMyAwIC4yNi0uMDUyLjM1OS0uMTU1bDE1Ljc2My0xNi4zNzdjLjE5OS0uMjA3LjE5OS0uNTQgMC0uNzQ3eiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPg==)] before:bg-center before:bg-no-repeat',
              ],
            )}
          >
            <div className={cn('text-sm font-semibold text-white uppercase', 'not-md:flex-1 not-md:text-xs')}>
              {notificationStore.notification.message}
            </div>
          </div>
        </div>
      )}
      <Root />
    </BrowserRouter>
  );
};
